import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=8d77efae&scoped=true"
import script from "./table-view.vue?vue&type=script&lang=js"
export * from "./table-view.vue?vue&type=script&lang=js"
import style0 from "./table-view.vue?vue&type=style&index=0&id=8d77efae&prod&scoped=true&lang=css"
import style1 from "./table-view.vue?vue&type=style&index=1&id=8d77efae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d77efae",
  null
  
)

export default component.exports